import { useState } from 'react';
import { NudosGenericModal, NudosModalContent } from '../../../../../../../components/NudosComponents';
import CustomModalContentSendProducts from './components/CustomModalContentSendProducts';
import { ISendProductsToWarehouse, IShipmentData } from '../../../../../../../types/orders';
import { sendProductsToWarehouse } from '../../../../../../../services/orders';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../../../utils/displayNudosStandardNotifications';

interface SendProductsToWarehouseModalProps {
  changeShowModal: () => void;
  orderId: number;
  organizationName?: string;
  shipmentPlace?: string;
  shipmentFlag?: string;
  nameCountry?: string;
  listOfGroupedShipments?: IShipmentData[];
  updateWithLoaders: () => void;
}
const SendProductsToWarehouseModal = ({
  changeShowModal,
  orderId,
  organizationName,
  shipmentPlace = '',
  shipmentFlag,
  nameCountry,
  listOfGroupedShipments,
  updateWithLoaders
}: SendProductsToWarehouseModalProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const closeModal = () => changeShowModal?.();

  const sendDataProductsToWarehouse = async () => {
    if (!listOfGroupedShipments || listOfGroupedShipments.length === 0) return;
    setLoading(true);
    try {
      const dataBody: ISendProductsToWarehouse = {
        shipmentGroupId: listOfGroupedShipments[0].shipmentGroupId
      };
      await sendProductsToWarehouse(dataBody);
      displaySuccessNotification({ customJSXMessage: <>El destino del envío se ha modificado correctamente</> });
      closeModal();
      updateWithLoaders();
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  return (
    <NudosGenericModal
      closeModalCallback={closeModal}
      clickOutsideCallback={closeModal}
      customClassName="sendProductsToWarehouseModal"
      modalContent={
        <NudosModalContent
          customWidth="580px"
          customHeight="480px"
          modalContentTitle="Enviar productos a la Bodega"
          customHeaderClass="sendProductsToWarehouseModalHeader"
          toCloseModal={closeModal}
          CustomModalComponent={
            <CustomModalContentSendProducts
              orderId={orderId}
              organizationName={organizationName}
              shipmentPlace={shipmentPlace}
              shipmentFlag={shipmentFlag}
              nameCountry={nameCountry}
              listOfGroupedShipments={listOfGroupedShipments}
              loading={loading}
              sendDataProductsToWarehouse={sendDataProductsToWarehouse}
            />
          }
        />
      }
    />
  );
};

export default SendProductsToWarehouseModal;
